export default __webpack_public_path__ + "static/suppliersLT-9933ab931b65e6028db83c18d796367a.png";